export default {
  strict: true,
  namespaced: true,
  state: {
    transactionList: []
  },
  mutations: {
    resetTransactionList (state) {
      state.transactionList = []
    },
    addTransaction (state, value) {
      state.transactionList.push(value)
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/transactions.js